import React from 'react';
import Swal from "sweetalert2";
import moment from 'moment';

import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";

import Cleave from 'cleave.js/react';
import "cleave.js/dist/addons/cleave-phone.i18n";


import DPCustom from 'components/DPCustom';

import * as commonFunc from 'scripts/common';

import {
    Input,
    Label,
    FormFeedback,
    InputGroup, InputGroupText, Col
} from "reactstrap";


export default function EditTextFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue, errors, control } = formManager;

    const [options, setOptions] = React.useState(data.options || []);
    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.subType && (data.subType.startsWith("date") || data.subType.startsWith("time"))) {//TODO : check si autre solution pour ne pas faire apparaitre de date via defaultValue
            var defaultValue = data.defaultValue || "";
            var dDateValue = getInitDate(defaultValue);
            formatValue(dDateValue, true);

        }
        if (data.subType === "phone") setValue(bindPropResult, data.defaultValue || "");

        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    function getInitDate(dateValue) {
        var initValue = dateValue;
        if (dateValue === "{true}") dateValue = new Date();
        else if (dateValue.startsWith && dateValue.startsWith("{M-")) {
            var modif = dateValue.replace("{M-", "").replace("}", "");
            dateValue = moment().subtract(parseFloat(modif), 'months').toDate();
        }
        else if (dateValue.startsWith && dateValue.startsWith("{W-")) {
            var modifWeeks = dateValue.replace("{W-", "").replace("}", "");
            dateValue = moment().subtract(parseFloat(modifWeeks), 'weeks').toDate();
        }
        else if (dateValue.startsWith && dateValue.startsWith("{D-")) {
            var modifDays = dateValue.replace("{D-", "").replace("}", "");
            dateValue = moment().subtract(parseFloat(modifDays), 'days').toDate();
        }
        var dDateValue = ((dateValue instanceof Date) ? dateValue : commonFunc.restStringToDate(dateValue));
        //Si date invalide (pas de type Date OU pas équivalent à 2023-12-12T00:00)
        if (!commonFunc.isValidDate(dDateValue)) {
            //dDateValue = (data.propNameJsType === "date" ? new Date() : initValue);
            dDateValue = (data.propNameJsType === "date" ? null : initValue);
            if (data.subType === "time") {
                var split = dateValue.split(":");
                //Si la date colle avec HH:mm
                if (split[0] && split[1]) dDateValue = moment().set({ 'hour': parseInt(split[0]), 'minute': parseInt(split[1]) }).toDate();
            }
        }
        else {
            if (initValue?.endsWith && initValue.endsWith("Z")) dDateValue = moment(dDateValue).toDate();
            else dDateValue = moment(dDateValue).utc(true).toDate();
        }
        if (dDateValue?.getFullYear && dDateValue.getFullYear() <= 1) dDateValue = moment(dateValue + "Z").toDate();
        return dDateValue;
    }

    function formatValue(valueInput, forceSet) {
        if (data.argumentsObj?.cleanInputChar) {
            valueInput = commonFunc.sanitizeString(valueInput);
            setValue(bindPropResult, valueInput);
        }
        if (data.subType === "integer" || data.subType === "float") {//PATCH 09/25
            valueInput = valueInput?.replace ? valueInput.replace(",", ".") : valueInput;
            var defaultSysValue = /*data.propNameJsType === "number" ? 0 :*/ "";/*(data.attributes && data.attributes.required !== undefined) ? 0 : ""*/;

            if (!forceSet) forceSet = isNaN(valueInput);
            valueInput = ((!commonFunc.isBlank(valueInput) || valueInput == 0) && (!isNaN(valueInput) || valueInput === "-") ? valueInput : defaultSysValue);
            if (data.subType === "integer") {
                if (!forceSet) forceSet = commonFunc.isBlank(valueInput) || (!(typeof valueInput === "number") && getValues(bindPropResult) !== parseInt(valueInput).toString());
                valueInput = parseInt(valueInput) || (valueInput === "-" ? valueInput : (parseInt(valueInput) === 0 ? 0 : defaultSysValue));
            }
            else if (data.subType === "float") {
                if (!forceSet) forceSet = commonFunc.isBlank(valueInput) || (!(typeof valueInput === "number") && getValues(bindPropResult) === parseFloat(valueInput).toString());
                valueInput = parseFloat(valueInput) || (valueInput === "-" ? valueInput : (parseFloat(valueInput) === 0 ? valueInput : defaultSysValue));
            }
        }
        else if (!forceSet && data.subType && (data.subType.startsWith("date") || data.subType.startsWith("time")) && data.propNameJsType !== "date") {
            forceSet = true;
        }
        if (((data.subType && (data.subType.startsWith("date") || data.subType.startsWith("time"))) && data.propNameJsType === "date") && valueInput === null && (!data.attributes || data.attributes.required === undefined)) valueInput = moment("1970-01-01T00:00").toDate();

        var formatValue = valueInput;
        if (data.format) {
            data.rawValue = valueInput;
            if (data.subType && (data.subType.startsWith("date") || data.subType.startsWith("time"))) {
                formatValue = moment(valueInput).format(data.format);
                if (commonFunc.isValidDate(moment(valueInput).toDate())) {
                    setValue(bindPropResult, formatValue);
                }
                else {
                    setValue(bindPropResult, valueInput);
                }
            }
        }
        else if (forceSet) {
            setValue(bindPropResult, valueInput);
        }
        return formatValue;
    }

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.isDisabled = () => { return (isConfiguration ? true : ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false))); };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.setValue = (value, withRerender, src) => {
        return new Promise((resolve, reject) => {
            //setValue(bindPropResult, value);
            formatValue(value, true);
            if (true) setShouldRender(!shouldRender);

            resolve({ isSuccess: true, result: value });
        });
    };
    data.functionManager.setDateonly = (value) => {
        return new Promise((resolve, reject) => {
            var val = bindPropResult ? getValues(bindPropResult) : "";
            var valueDate = data.rawValue || val;
            var dateValue = commonFunc.restStringToDate(moment(value).format("YYYY-MM-DDT") + (moment(valueDate).isValid() ? moment(valueDate).format("HH:mm") : "00:00"));
            //setValue(bindPropResult, dateValue);
            if (commonFunc.isValidDate(dateValue)) {
                formatValue(dateValue, true);

                onChange();


                resolve({ isSuccess: true, result: dateValue });
            }
        });
    };
    data.functionManager.getValue = (src) => {
        return bindPropResult ? getValues(bindPropResult) : "";
    };
    data.functionManager.populateData = populateData;
    data.functionManager.findItem = (value) => {
        return options.filter(item => item.value === value);
    };
    data.functionManager.triggerChange = (alternativeValue) => {
        return new Promise((resolve, reject) => {
            onChange();

            resolve({ isSuccess: true, result: null });
        });
    };

    //console.debug("test value " + bindPropResult + " " + data.defaultValue);

    var defaultValue = data.defaultValue !== undefined ? data.defaultValue : "";
    var formValue = getValues(bindPropResult);
    defaultValue = (data.subType === "integer" || data.subType === "float") ? ((formValue || formValue === 0) ? formatValue(formValue) : formatValue(defaultValue)) : defaultValue;

    const { ref: refElem, ...restElem } = register(bindPropResult, {
        value: defaultValue,
        //valueAsNumber: (data.subType === "integer" || data.subType === "float"),
        setValueAs: (v) => {//PATCH 09/25
            if (data.subType === "integer" || data.subType === "float") {
                if (v === "") return 0;
                if (data.subType === "integer") return parseInt(v);
                if (data.subType === "float") return parseFloat(v);
                return v;
            }
            else if (data.subType && (data.subType.startsWith("date") || data.subType.startsWith("time")) && data.propNameJsType !== "date") {
                return commonFunc.isValidDate(new Date(v)) ? new Date(v).toISOString() : v;
            }
            else {
                return v;
            }
        },
        valueAsDate: ((data.subType && (data.subType.startsWith("date") || data.subType.startsWith("time"))) && data.propNameJsType === "date"),
        onChange: (e) => {
            onChange(e.target.value);
        }   
    });

    var disabled = (isConfiguration ? true : ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false)));


    function onChange(inputVal) {
        //console.debug("onChange");
        var val = (data.subType === "integer" || data.subType === "float") ? (inputVal || (inputVal == 0 ? inputVal : (bindPropResult ? getValues(bindPropResult) : ""))) : (bindPropResult ? getValues(bindPropResult) : "");
        formatValue(val);
        if (((data.subType && (data.subType.startsWith("date") || data.subType.startsWith("time"))) && data.propNameJsType === "date") && val === null && (!data.attributes || data.attributes.required === undefined)) setValue(bindPropResult, moment("1970-01-01T00:00").toDate());

        if (data.onActionEvents && data.onActionEvents["onChange"]) {
            data.onActionEvents["onChange"].forEach((args, index) => {
                var val = bindPropResult ? getValues(bindPropResult) : "";
                modelFctManager.onActionRequired(data.name, args, data, { type: data.subType, value: (data.rawValue || val) }).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
    }

    function populateData(dataOptions, triggerOnChange) {
        return new Promise((resolve, reject) => {
            //console.debug("spinnerFrag populateOptions " + bindPropResult);
            //data.options = dataOptions;
            var defaultOptions = data.options ? data.options.filter((opt) => opt.subType === "default") : [];
            var componentVal = bindPropResult ? getValues(bindPropResult) : "";
            if (dataOptions && dataOptions.length) {
                var newOptions = [...defaultOptions, ...dataOptions];
                setOptions(newOptions);

                if (triggerOnChange) onChange();

                resolve({ isSuccess: true, result: componentVal });
            }
            else {
                setOptions(defaultOptions);

                if (triggerOnChange) onChange(componentVal);

                resolve({ isSuccess: true, result: componentVal });
            }
        });
    }

    function renderInput(inputClass, inputStyle) {
        //TODO : formattage chargement valeurs

        if (data.subType && (data.subType.startsWith("date") || data.subType.startsWith("time"))) {
            var minDate = (data.attributes && data.attributes) ? data.attributes.min : undefined;
            if (minDate) minDate = getInitDate(minDate);
            var minTime = (data.attributes && data.attributes) ? data.attributes.min : undefined;
            if (minTime) minTime = getInitDate(minTime);
            var maxDate = (data.attributes && data.attributes) ? data.attributes.max : undefined;
            if (maxDate) maxDate = getInitDate(maxDate);
            var maxTime = (data.attributes && data.attributes) ? data.attributes.max : undefined;
            if (maxTime) maxTime = getInitDate(maxTime);
        }

        var configObj = {};
        var overrideObj = {};
        if (isConfiguration) configObj = { key: Math.floor(Math.random() * 1000000000), value: (defaultValue || "") };

        if (data.argumentsObj?.overrideDP) {
            overrideObj = { ...overrideObj, ...data.argumentsObj.overrideDP };
            if (data.argumentsObj.overrideDP.dateFormat === "MM/yyyy") {
                overrideObj.customInput = <Cleave autoComplete="no" aria-autocomplete="none" options={{ date: true, delimiter: '/', datePattern: ['m', 'Y'] }} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} />;
            }
            else if (data.argumentsObj.overrideDP.dateFormat === "yyyy") {
                overrideObj.customInput = <Cleave autoComplete="no" aria-autocomplete="none" options={{ date: true, delimiter: '/', datePattern: ['Y'] }} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} />;
            }
        }

        switch (data.subType) {
            case "datetime":
                //var dDateValue = commonFunc.restStringToDate(data.defaultValue);
                var dDateValue = "";
                if (defaultValue) {
                    dDateValue = getInitDate(defaultValue);
                    if (!(dDateValue instanceof Date)) dDateValue = "";
                }
                return <Controller
                    control={control}
                    name={bindPropResult}
                    render={({ field: { ref, ...field } }) => (
                        <DPCustom
                            id={"input" + bindPropResult}
                            parentClassName={`p-0 ${inputClass}`}
                            className={`form-control`}
                            /*defaultValue={defaultValue}*/ readOnly={data.readOnly}
                            showWeekNumbers={false}
                            dateFormat="dd/MM/yyyy"
                            timeFormat="HH:mm"
                            minDate={minDate}
                            minTime={minTime}
                            maxDate={maxDate}
                            maxTime={maxTime}
                            locale="fr"
                            placeholderText={!commonFunc.isBlank(data.placeHolder) ? altT(data.placeHolder) : "__/__/____ __:__"}
                            autoComplete="no" aria-autocomplete="none"
                            selected={(data.rawValue || ((field.value instanceof Date) ? field.value : dDateValue))}
                            disabled={disabled}

                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Heure"

                            innerRef={ref} {...field}
                            {...configObj}
                            value={data.rawValue || ((field.value instanceof Date) ? field.value : dDateOValue)}
                            invalid={commonFunc.getValue(errors, bindPropResult) ? true : false}

                            customInput={
                                <Cleave autoComplete="no" aria-autocomplete="none" options={{ date: true, delimiter: '/', datePattern: ['d', 'm', 'Y'] }} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} />
                                //<Cleave options={{ delimiters: ['/', '/', ' ', ':'], blocks: [2, 2, 4, 2, 2] }} />
                            }
                            {...overrideObj}
                        />
                    )}
                />;
            case "date":
            case "date_instant":
            case "dateonly":
                //var dDateOValue = commonFunc.restStringToDate(data.defaultValue);
                var dDateOValue = "";
                if (defaultValue) {
                    dDateOValue = getInitDate(defaultValue);
                    if (!(dDateOValue instanceof Date)) dDateOValue = "";
                }
                return <Controller
                    control={control}
                    name={bindPropResult}
                    render={({ field: { ref, ...field } }) => {
                        //console.debug(data.rawValue);
                        //console.debug(field.value);

                        var displayDate = data.rawValue || ((field.value instanceof Date || commonFunc.isValidDate(new Date(field.value))) ? new Date(field.value) : dDateOValue);
                        if (((!data.argumentsObj || !data.argumentsObj.allowEpoch) && (new Date(displayDate).getFullYear() <= 1970 || new Date(displayDate).getFullYear() >= 2099)) || (data.argumentsObj?.blankEpoch && moment("1970-01-01T00:00").isSame(moment(displayDate)))) displayDate = "";
                        return (
                            <DPCustom
                                id={"input" + bindPropResult}
                                parentClassName={`p-0 ${inputClass}`}
                                className={`form-control`}
                                /*defaultValue={defaultValue}*/ readOnly={data.readOnly}
                                showWeekNumbers={false}
                                dateFormat="dd/MM/yyyy"
                                timeFormat={false}
                                minDate={minDate}
                                minTime={minTime}
                                maxDate={maxDate}
                                maxTime={maxTime}
                                locale="fr"
                                placeholderText={!commonFunc.isBlank(data.placeHolder) ? altT(data.placeHolder) : "__/__/____"}
                                autoComplete="no" aria-autocomplete="none"
                                selected={commonFunc.isBlank(displayDate) ? new Date() : displayDate}
                                disabled={disabled}
                                innerRef={ref} {...field}
                                {...configObj}
                                value={displayDate}
                                invalid={commonFunc.getValue(errors, bindPropResult) ? true : false}

                                customInput={
                                    <Cleave autoComplete="no" aria-autocomplete="none" options={{ date: true, delimiter: '/', datePattern: ['d', 'm', 'Y'] }} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} />
                                }
                                {...overrideObj}
                            />
                        );
                    }}
                />;
            case "time_instant":
            case "time":
                //var dTimeValue = commonFunc.restStringToDate(data.defaultValue);
                var dTimeValue = "";
                if (defaultValue) {
                    dTimeValue = getInitDate(defaultValue);
                    if (!(dTimeValue instanceof Date)) dTimeValue = "";
                }
                return <Controller
                    control={control}
                    name={bindPropResult}
                    render={({ field: { ref, ...field } }) => {
                        //console.debug(data.rawValue);
                        //console.debug(field.value);

                        var displayDate = data.rawValue || ((field.value instanceof Date || commonFunc.isValidDate(new Date(field.value))) ? new Date(field.value) : dDateOValue);
                        if ((!data.argumentsObj || !data.argumentsObj.allowEpoch) && (new Date(displayDate).getHours() <= 0 && new Date(displayDate).getMinutes() <= 0)) displayDate = "";
                        return (
                            <DPCustom
                                id={"input" + bindPropResult}
                                parentClassName={`p-0 ${inputClass}`}
                                className={`form-control`}
                                readOnly={data.readOnly}
                                showWeekNumbers={false}
                                dateFormat={"HH:mm"}
                                timeFormat="HH:mm"
                                minDate={minDate}
                                minTime={minTime}
                                maxDate={maxDate}
                                maxTime={maxTime}
                                locale="fr"
                                placeholderText={!commonFunc.isBlank(data.placeHolder) ? altT(data.placeHolder) : "__:__"}
                                autoComplete="no" aria-autocomplete="none"
                                selected={(data.rawValue || ((field.value instanceof Date) ? field.value : dTimeValue))}
                                disabled={disabled}

                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="Heure"

                                innerRef={ref} {...field}
                                {...configObj}
                                value={displayDate}
                                invalid={commonFunc.getValue(errors, bindPropResult) ? true : false}

                                customInput={
                                    <Cleave autoComplete="no" aria-autocomplete="none" options={{ time: true, timePattern: ['h', 'm'] }} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} />
                                }
                                {...overrideObj}
                            />
                        );
                    }}
                />;
            case "text_5":
            case "text_5_html":
                return <Input type="textarea" id={"input" + bindPropResult} className={`${inputClass}`} placeholder={altT(data.placeHolder)} /*defaultValue={defaultValue || ""}*/ readOnly={data.readOnly} autoComplete="no" aria-autocomplete="none"
                    cols="5" rows="3" style={{ resize: "auto", maxHeight: "none", ...inputStyle }} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null} disabled={disabled} list={"inputList" + bindPropResult}
                    innerRef={refElem} {...restElem} invalid={commonFunc.getValue(errors, bindPropResult) ? true : false} {...overrideObj} />;
            case "integer":
            case "float"://TODO : check si autre solution pour ne pas faire apparaitre le zéro via defaultValue
                return <Input type="text" id={"input" + bindPropResult} className={`${inputClass}`} placeholder={altT(data.placeHolder)} /*defaultValue={defaultValue || 0}*/ readOnly={data.readOnly} autoComplete="no" aria-autocomplete="none"
                    disabled={disabled} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null}
                    innerRef={refElem} {...restElem} {...configObj} invalid={commonFunc.getValue(errors, bindPropResult) ? true : false} {...overrideObj} />;
            case "phone":
                return <Controller
                    control={control}
                    name={bindPropResult}
                    render={({ field: { ref, ...field } }) => (
                        <Cleave id={"input" + bindPropResult} className={`form-control ${inputClass} ${commonFunc.getValue(errors, bindPropResult) ? "is-invalid" : ""}`} placeholder={altT(data.placeHolder)} readOnly={data.readOnly} autoComplete="no" aria-autocomplete="none"
                            options={{ phone: true, phoneRegionCode:"FR" }}//TODO : phoneRegionCode gestion pays
                            disabled={disabled} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null}
                            htmlRef={ref} {...field} {...configObj} {...overrideObj} />
                    )}
                />;
            case "password":
                return <Input type="password" id={"input" + bindPropResult} className={`${inputClass}`} placeholder={altT(data.placeHolder)} /*defaultValue={defaultValue || ""}*/ readOnly={data.readOnly} autoComplete="new-password" aria-autocomplete="none"
                    disabled={disabled} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null}
                    innerRef={refElem} {...restElem} invalid={commonFunc.getValue(errors, bindPropResult) ? true : false} {...overrideObj} />;
            case "default"://TEMP
                return <Input type="text" id={"input" + bindPropResult} className={`${inputClass} ${data.format}`} placeholder={altT(data.placeHolder)} /*defaultValue={defaultValue || ""}*/ readOnly={data.readOnly} autoComplete="no" aria-autocomplete="none"
                    disabled={disabled} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null}
                    innerRef={refElem} {...restElem} {...configObj} /*valid={commonFunc.getValue(errors, bindPropResult) ? false : true}*/ invalid={commonFunc.getValue(errors, bindPropResult) ? true : false} {...overrideObj} />;
            case "email":
            default:
                return <Controller
                    control={control}
                    name={bindPropResult}
                    render={({ field: { ref, ...field } }) => (
                        <Cleave id={"input" + bindPropResult} className={`form-control ${inputClass} ${data.format} ${/*formManager.isSubmitted && !commonFunc.getValue(errors, bindPropResult) && getValues(bindPropResult) ? "is-valid" : */""} ${commonFunc.getValue(errors, bindPropResult) ? "is-invalid" : ""}`} placeholder={altT(data.placeHolder)} /*defaultValue={defaultValue || ""}*/ readOnly={data.readOnly} autoComplete="no" aria-autocomplete="none"
                            options={{ delimiter: "@#/*", lowercase: (data.argumentsObj?.lowercase ? data.argumentsObj.lowercase : false), uppercase: (data.argumentsObj?.uppercase ? data.argumentsObj.uppercase : false) }}
                            disabled={disabled} list={"inputList" + bindPropResult} style={inputStyle} data-backimage={inputStyle.hasImage || null} data-imageopacity={inputStyle.alpha || null}
                            htmlRef={ref} {...field} {...configObj} {...overrideObj} />
                    )}
                />;

        }
    }

    function renderTitle(positions, titleWidthClass, titleWidthStyle) {
        var design = data.customDesign ? data.customDesign.designTitle : null;
        if (!design) design = {}
        var position = design.position;
        if (position === "floating" && (data.subType?.startsWith("date") || data.subType?.startsWith("time"))) position = "left";
        if (!position) position = "left";

        var titleModel = <div className={`${titleWidthClass}`} style={titleWidthStyle} data-backimage={titleWidthStyle?.hasImage || null} data-imageopacity={titleWidthStyle?.alpha || null}><Label className={` ${(position === "left" || position === "right") ? "m-0" : ""} ${(!commonFunc.isBlank(data.title) && data.required) ? "mandatory" : ""}`} for={"input" + bindPropResult}>{altT(data.title)}</Label></div>;

        if (position === "floating") titleModel = <Label className={` ${(position === "left" || position === "right") ? "m-0" : ""} ${(!commonFunc.isBlank(data.title) && data.required) ? "mandatory" : ""} ${titleWidthClass}`} style={titleWidthStyle} for={"input" + bindPropResult}>{altT(data.title)}</Label>;
        if (!commonFunc.isBlank(data.title) && positions.indexOf(position) >= 0) return titleModel;
        else return "";
    }

    var frameClass = "mb-3";
    var frameStyle = {};
    var containerClass = "";
    var containerStyle = {};
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "form-group m-0 ";

    var widthClass = "";
    var inputClass = "";
    var inputStyle = {};
    var titleWidthClass = "px-0 ";
    var titleWidthStyle = { color: "rgb(37, 36, 34)" };

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_text");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass += modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }
        if (design.margin) {
            frameStyle.margin = design.margin;
            frameClass = frameClass.replace("mb-3", "");
        }
        if (design.width) containerStyle.width = design.width;
    }
    var designInput = data.customDesign?.designInput;
    designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_textInput", true);
    if (designInput) {
        if (designInput.boxSize) {
            //widthClass += " w-" + parseInt(parseFloat(designInput.boxSize) * 100);
            widthClass += modelFctManager.convertWidthToGrid(parseFloat(designInput.boxSize) * 100);
        }


        Object.assign(inputStyle, modelFctManager.setCustomBackground(designInput, data));
        //Object.assign(inputStyle, modelFctManager.managePadding(designInput, inputClass));
        Object.assign(inputStyle, modelFctManager.manageMargin(designInput, inputClass));


        //TODO : icon

        if (designInput.size || designInput.width) inputStyle.width = (designInput.size ? (designInput.size + "px") : designInput.width);
        if (designInput.height) inputStyle.height = designInput.height;

        if (designInput.fontColor) inputStyle.color = modelFctManager.getRgbaFromHex(designInput.fontColor);
        if (designInput.fontSize) inputStyle.fontSize = designInput.fontSize;
        if (designInput.fontStyle) {
            if (designInput.fontStyle.indexOf("bold") >= 0) inputStyle.fontWeight = "bold";
            if (designInput.fontStyle.indexOf("italic") >= 0) inputStyle.fontStyle = "italic";
        }

        if (designInput.alignment) {//TODO : TO CHECK
            var split = designInput.alignment.split("|");
            split.forEach((part) => {
                inputClass += " text-" + part.replace("left", "start").replace("right", "end");
                inputClass = inputClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }

    }
    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_textTitle", true);
    if (designTitle) {
        Object.assign(titleWidthStyle, modelFctManager.setCustomBackground(designTitle, data));
        //Object.assign(titleWidthStyle, modelFctManager.managePadding(designTitle, titleWidthClass));
        Object.assign(titleWidthStyle, modelFctManager.manageMargin(designTitle, titleWidthClass));

        if (designTitle.size || designTitle.width) titleWidthStyle.width = (designTitle.size ? (designTitle.size + "px") : designTitle.width);
        if (designTitle.height) titleWidthStyle.height = designTitle.height;

        if (designTitle.fontColor) titleWidthStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleWidthStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleWidthStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleWidthStyle.fontStyle = "italic";
        }

        if (designTitle.alignment) {
            var splitTitle = designTitle.alignment.split("|");
            splitTitle.forEach((part) => {
                titleWidthClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleWidthClass = titleWidthClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }

        //PATCH : floating incompatible avec react-datepicker en WEB
        if (designTitle.position === "floating" && (!data.subType || (!data.subType.startsWith("date") && !data.subType.startsWith("time")))) {
            data.placeHolder = data.title;
            formClass += " form-floating min-input";
        }
        if (designTitle.boxSize) {
            //titleWidthClass += " w-" + parseInt(parseFloat(designTitle.boxSize) * 100);
            titleWidthClass += modelFctManager.convertWidthToGrid(parseFloat(designTitle.boxSize) * 100);
            titleWidthClass = titleWidthClass.replace("px-0", "ps-3 px-md-0").replace("text-end", "text-md-end");
        }
    }

    if (!commonFunc.isBlank(widthClass) || titleWidthClass !== "px-0 ") containerClass += " row m-0 row-cols-lg-auto2 align-items-center";


    var inputContainer = renderInput(inputClass, inputStyle);
    if (options && options.length) {
        inputContainer = <>{inputContainer}<datalist id={"inputList" + bindPropResult}>{options.map((option, optIndex) => <option key={optIndex} value={option.value}>{option.title}</option>)}</datalist></>;
    }
    if (data.children) {
        inputContainer = <div className="d-flex">{inputContainer}{data.children.map((child) => modelFctManager.componentTyped(child, parentProps))}</div>
    }


    var baseForm = <div className={`${containerClass} ${formClass}`} style={containerStyle}>
        {renderTitle(["top", "left"], titleWidthClass, titleWidthStyle)}
        <div className={`${widthClass}`}>
            {inputContainer}
            <FormFeedback className={`text-start ${commonFunc.getValue(errors, bindPropResult) ? "d-block" : ""}`}>{commonFunc.getValue(errors, bindPropResult) ? commonFunc.getValue(errors, bindPropResult).message : t("gal_reqFields")}</FormFeedback>
        </div>
        {renderTitle(["bottom", "right", "floating"], titleWidthClass, titleWidthStyle)}
    </div>;

    if (data.customDesign?.designTitle?.position === "floating" && (!data.subType || (!data.subType.startsWith("date") && !data.subType.startsWith("time")))) {
        baseForm = <div className={`${containerClass}`} style={containerStyle}>
            <div className={`${widthClass} ${formClass}`}>
                <div className={`${formClass}`}>
                    {inputContainer}
                    {renderTitle(["floating"])}
                </div>
            </div>
            <FormFeedback className={`text-start ${commonFunc.getValue(errors, bindPropResult) ? "d-block" : ""}`}>{commonFunc.getValue(errors, bindPropResult) ? commonFunc.getValue(errors, bindPropResult).message : t("gal_reqFields")}</FormFeedback>
        </div>;
    }

    if (data.customDesign?.designIcon) {
        var iconDesign = data.customDesign.designIcon;

        var iconStyle = {};
        if (iconDesign.fontColor) iconStyle.color = modelFctManager.getRgbaFromHex(iconDesign.fontColor);
        if (iconDesign.fontSize) iconStyle.fontSize = iconDesign.fontSize;

        baseForm = <div className={`${containerClass}`} style={containerStyle}>
            {renderTitle(["top", "left"], titleWidthClass, titleWidthStyle)}
            <InputGroup className={`single-input ${widthClass}`}>
                <InputGroupText className={`${(data.attributes && data.attributes.required !== undefined) ? "mandatory" : ""}`} title={data.customDesign && data.customDesign.designTitle && data.customDesign.designTitle.position === "title" ? altT(data.title) : ""} >
                    <i className={`fa ${iconDesign.icon.replace(/_/g, "-")}`} style={iconStyle} />
                </InputGroupText>
                <div className={`${formClass}`} style={{flex:1}}>
                    {inputContainer}
                    {renderTitle(["floating"])}
                </div>
                <FormFeedback className={`text-start ${commonFunc.getValue(errors, bindPropResult) ? "d-block" : ""}`}>{commonFunc.getValue(errors, bindPropResult) ? commonFunc.getValue(errors, bindPropResult).message : t("gal_reqFields")}</FormFeedback>
            </InputGroup>
            {renderTitle(["bottom", "right"], titleWidthClass, titleWidthStyle)}
        </div>;
    }
    //console.debug("render input");

    return <Col data-name="EditTextFrag" data-element={data.objType} xs="auto" className={`${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}